<template>
  <div>
    <!-- user_session.role_id: {{ user_session.role_id }} -->

    <div class="vx-row" v-if="user_session.role_id == 1">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 mb-base" :key="index"
        v-for="(item, index) in data_dashboard.kpis">
        <vx-card class="flex flex-col items-center justify-center text-center p-0">
          <vs-avatar size="large" color="success" style="font-size: 3vh;" :text="item.name" />
          <div style="font-size: 4.5vh; font-weight: 900;"> <span style="font-size: 3vh;">B/.</span>​ {{
            redondearAMillones(item.value) }} </div>
          <div style="font-size: 2vh;" class="text-success">
            {{ item.name }}
          </div>
        </vx-card>
      </div>
    </div>


    <div class="vx-row" v-if="user_session.role_id == 1">

      <div class="vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card style="height: 400px;">
          <h5>Deudas por tipo de cuenta</h5>
          <vue-apex-charts v-if="chartSeries_deuda_tipo_cuenta && chartSeries_deuda_tipo_cuenta.length" type="pie" height="327" :options="chartOptions_deuda_tipo_cuenta"
            :series="chartSeries_deuda_tipo_cuenta" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card style="height: 400px;">
          <h5>Deudas por cliente</h5>
          <vue-apex-charts v-if="chartOptions_deuda_cliente && chartSeries_deuda_cliente && chartSeries_deuda_cliente.length" type="bar" height="327" :options="chartOptions_deuda_cliente"
            :series="chartSeries_deuda_cliente" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card>
          <h5>Deudas por cliente prepago</h5>
          <vue-apex-charts v-if="chartOptions_deuda_cliente_prepago && chartSeries_deuda_cliente_prepago && chartSeries_deuda_cliente_prepago.length" type="bar" height="327" :options="chartOptions_deuda_cliente_prepago"
            :series="chartSeries_deuda_cliente_prepago" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card>
          <h5>Deudas por cliente postpago</h5>
          <vue-apex-charts v-if="chartOptions_deuda_cliente_postpago && chartSeries_deuda_cliente_postpago && chartSeries_deuda_cliente_postpago.length" type="bar" height="327" :options="chartOptions_deuda_cliente_postpago"
            :series="chartSeries_deuda_cliente_postpago" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>

      <div class="vx-col w-full mb-base">
        <vx-card>
          <h5>Deudas por antiguedad</h5>
          <graph-antiquity :datos="data_dashboard && data_dashboard.deuda_antiguedad_afiliacion ? data_dashboard.deuda_antiguedad_afiliacion : []" />
        </vx-card>
      </div>

      <div class="vx-col w-full mb-base">
        <vx-card>
          <h5>Deudas por segmentación</h5>
          <vue-apex-charts v-if="chartOptions_deuda_segmentacion && chartSeries_deuda_segmentacion && chartSeries_deuda_segmentacion.length" type="bar" height="327" :options="chartOptions_deuda_segmentacion"
            :series="chartSeries_deuda_segmentacion" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card>
          <h5>Deudas por segmentación - Prepago</h5>
          <vue-apex-charts v-if="chartOptions_deuda_segmentacion_prepago && chartSeries_deuda_segmentacion_prepago && chartSeries_deuda_segmentacion_prepago.length" type="bar" height="327" :options="chartOptions_deuda_segmentacion_prepago"
            :series="chartSeries_deuda_segmentacion_prepago" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card>
          <h5>Deudas por segmentación - Postpago</h5>
          <vue-apex-charts v-if="chartOptions_deuda_segmentacion_postpago && chartSeries_deuda_segmentacion_postpago && chartSeries_deuda_segmentacion_postpago.length" type="bar" height="327" :options="chartOptions_deuda_segmentacion_postpago"
            :series="chartSeries_deuda_segmentacion_postpago" />
          <div v-else class="text-center p-8 text-grey">Cargando gráfico...</div>
        </vx-card>
      </div>
      <br><br><br>
    </div>

    <div class="vx-row" v-if="user_session.role_id == 1">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base" :key="index"
        v-for="(item, index) in data_kpis_empresas">
        <vx-card class="flex flex-col items-center justify-center text-center">
          <vs-avatar size="large" color="success" style="font-size: 3vh;" :text="item.com_name" />
          <div style="font-size: 4.5vh; font-weight: 900;"><span style="font-size: 3vh;">B/.</span>​ {{
            formatNumber(item.kpi) }} </div>
          <div style="font-size: 2vh;" class="text-success">
            {{ item.cantidad }} <span v-if="item.cantidad > 1">asignaciones</span><span v-else>asignación</span>
          </div>
          <div style="font-size: 2vh;"> {{ item.com_name }} </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row" v-if="data_kpis.length > 0">
      <div :key="index" v-for="(item, index) in data_kpis" class="vx-col mb-base"
        :class="data_kpis.length === 1 ? 'w-full' : 'w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4'">
        <!-- Contenido del div -->
        <vx-card class="flex flex-col items-center justify-center text-center">
          <vs-avatar size="large" color="primary" style="font-size: 3vh;" :text="item.gestor || item.collector_name" />
          <div style="font-size: 4.5vh; font-weight: 900;"><span style="font-size: 3vh;">B/.</span>​ {{
            formatNumber(item.total_saldo) }} </div>
          <div style="font-size: 2vh;" class="text-success">
            {{ item.cantidad }} <span v-if="item.cantidad > 1">asignaciones</span><span v-else>asignación</span>
          </div>
          <div style="font-size: 2vh;"> {{ item.collector_name }} </div>
        </vx-card>
      </div>
    </div>

    <vx-card v-else-if="user_session.role_id != 1" class="flex flex-col items-center justify-center text-center">
      <vs-avatar size="large" color="primary" style="font-size: 3vh;" :text="user_session.user_name" />
      <div style="font-size: 4.5vh; font-weight: 900;"><span style="font-size: 3vh;">B/.</span>​ 0 </div>
      Sin asignaciones
      <div style="font-size: 2vh;" class="text-success">
        0 asignaciones
      </div>
      <div style="font-size: 2vh;" class="capitalize"> {{ user_session.user_name }} </div>
    </vx-card>

  </div>
</template>

<script>
  import axios from '@/axios'
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import VueApexCharts from "vue-apexcharts";
  import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
  import GraphAntiquity from './graph_antiguedad_seg.vue';
  import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";

  function formatNumberES(value) {
    if (value === null || value === undefined || value === '') return '0,00';
    let cleanValue = value;
    if (typeof value === 'string') {
      cleanValue = value.replace(/,/g, '').trim();
    }
    const number = Number(cleanValue);
    if (Number.isNaN(number)) return '0,00';
    return number.toLocaleString('es-VE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  export default {
    components: {
      VueApexCharts,
      StatisticsCardLine,
      VuePerfectScrollbar,
      ChangeTimeDurationDropdown,
      GraphAntiquity,
    },
    data() {
      return {
        user_session: {},
        config: null,
        data_kpis: [],
        companies: [],
        data_kpis_empresas: [],
        data_dashboard: [],

        chartOptions_deuda_tipo_cuenta: {
          labels: ["Monto Prepago", "Total No Afiliados", "Monto Postpago", "Otros"],
          colors: ['#0DB491', '#F54927', '#FFCE56', '#36A2EB', '#9966FF'],
          tooltip: {
            y: { formatter: (val) => formatNumberES(val) }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
        chartOptions_deuda_segmentacion: {
          labels: [],
          colors: ['#0DB491', '#F54927', '#FFCE56', '#36A2EB'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
        chartSeries_deuda_tipo_cuenta: [],
        chartSeries_deuda_segmentacion: [],

        chartSeries_deuda_cliente: [],
        chartOptions_deuda_cliente: null,

        chartSeries_deuda_cliente_prepago: [],
        chartOptions_deuda_cliente_prepago: null,

        chartSeries_deuda_cliente_postpago: [],
        chartOptions_deuda_cliente_postpago: null,

        chartSeries_deuda_antiguedad: [],
        chartOptions_deuda_antiguedad: null,

        chartSeries_deuda_segmentacion: [],
        chartOptions_deuda_segmentacion: null,

        chartSeries_deuda_segmentacion_prepago: [],
        chartOptions_deuda_segmentacion_prepago: null,

        chartSeries_deuda_segmentacion_postpago: [],
        chartOptions_deuda_segmentacion_postpago: null,

        // chartSeries_deuda_antiguedad_afiliacion: [],
        // chartOptions_deuda_antiguedad_afiliacion: null,

      };
    },
    computed: {

    },
    mounted() {
      this.user_session = localStorage.user_session ? JSON.parse(localStorage.user_session) : {};
      this.config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.accessToken,
        },
      }
      this.get_data_dashboard()
      this.get_kpi_empresa()
      this.get_kpi_gestor()
    },
    methods: {
      setSubmenu(item) {

      },
      get_kpi_gestor() {
        let me = this
        this.$vs.loading()
        axios
          .get(`auth/get_kpi_gestor`, this.config)
          .then(function (response) {
            me.data_kpis = response.data
            me.$vs.loading.close()
          })
          .catch(function (error) {
            me.$vs.loading.close()
          })
      },
      get_kpi_empresa() {
        let me = this
        this.$vs.loading()
        axios
          .get(`auth/get_kpi_empresa`, this.config)
          .then(function (response) {
            me.data_kpis_empresas = response.data
            me.$vs.loading.close()
          })
          .catch(function (error) {
            me.$vs.loading.close()
          })
      },
      redondearAMillones(numero) {
        if (numero >= 1000000) {
          return (Math.round(numero / 100000) / 10).toFixed(1) + "M";
        } else {
          return (Math.round(numero / 1000)).toFixed(0) + "K";
        }
      },
      formatNumber(value) {
        return formatNumberES(value);
      },
      get_data_dashboard() {
        let me = this
        this.$vs.loading()
        axios
          .get(`auth/get_data_dashboard`, this.config)
          .then(function (response) {
            if (!response.data || response.data.success === 0 || !Array.isArray(response.data.kpis)) {
              console.error("Error al cargar datos del dashboard:", response.data && response.data.error ? response.data.error : response.data);
              me.$vs.loading.close()
              return;
            }

            me.data_dashboard = response.data
            let data_tipo_cuenta_chart = response.data.kpis || []
            const cleaned_tipo_cuenta = data_tipo_cuenta_chart.filter(
              x => x && !["Total Global", "Total Afiliados"].includes(x.name)
            );
            me.chart_deuda_tipo_cuenta(cleaned_tipo_cuenta)
            me.chart_deuda_cliente(response.data.deuda_cliente || [])
            me.chart_deuda_cliente_prepago(response.data.deuda_cliente_prepago || [])
            me.chart_deuda_cliente_postpago(response.data.deuda_cliente_postpago || [])
            me.chart_deuda_antiguedad(response.data.deuda_antiguedad || [])
            me.chart_deuda_segmentacion(response.data.deuda_segmentacion || [])
            me.chart_deuda_segmentacion_prepago(response.data.deuda_segmentacion_tipo_cuenta || [])
            me.chart_deuda_segmentacion_postpago(response.data.deuda_segmentacion_tipo_cuenta || [])

            me.$vs.loading.close()
          })
          .catch(function (error) {
            console.log(error)
            me.$vs.loading.close()
          })
      },
      chart_deuda_tipo_cuenta(data) {
        const labels = data.map(item => item.name);
        const series = data.map(item => Math.abs(item.value));

        this.chartOptions_deuda_tipo_cuenta.labels = labels;
        this.chartSeries_deuda_tipo_cuenta = series;
      },
      chart_deuda_cliente(data) {
        // console.log('chart_deuda_cliente', data);
        const categories = data.map(item => item.currentOwnerName);
        const values = data.map(item => parseFloat(item.value)); // Asegura que sea número (por si viene como string de la DB)

        this.chartSeries_deuda_cliente = [{
          name: 'Deuda Total', // Opcional: agrega un nombre para la serie
          data: values
        }];

        this.chartOptions_deuda_cliente = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: false // false si no necesitas stacked; ajusta si es intencional
          },
          plotOptions: {
            bar: {
              horizontal: true,
              // borderRadius: 4, // suaviza las barras
              dataLabels: {
                position: 'top' // Muestra el valor formateado directamente en la barra
              }
            }
          },
          dataLabels: {
            enabled: true, // Habilita labels en las barras con formato
            formatter: function (value) {
              const number = Number(value);
              return number.toLocaleString('es-VE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            },
            style: {
              fontSize: '12px',
              colors: ['#304758']
            },
            offsetX: 0,
          },
          xaxis: {
            categories: categories,
            labels: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                });
              },
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + ' (Deuda)';
              }
            }
          },
          colors: ['#008FFB'],
        };
      },
      chart_deuda_cliente_prepago(data) {
        const categories = data.map(item => item.currentOwnerName);
        const values = data.map(item => parseFloat(item.value)); // Mantén como números para escalado correcto

        this.chartSeries_deuda_cliente_prepago = [{
          name: 'Deuda Prepago', // Opcional: nombre para la serie
          data: values
        }];

        this.chartOptions_deuda_cliente_prepago = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true // Mantenido si es intencional
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4, // Opcional: suaviza las barras
              dataLabels: {
                position: 'top' // Muestra valor en la barra
              }
            }
          },
          dataLabels: {
            enabled: true, // Habilita labels formateados en las barras
            formatter: function (value) {
              const number = Number(value);
              return number.toLocaleString('es-VE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            },
            style: {
              fontSize: '12px',
              colors: ['#304758']
            },
            offsetX: 0,
          },
          xaxis: {
            categories: categories,
            labels: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                });
              },
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + ' (Deuda Prepago)';
              }
            }
          },
          colors: ['#00E396'], // Color verde para prepago; ajusta si prefieres
        };
      },
      chart_deuda_cliente_postpago(data) {
        const categories = data.map(item => item.currentOwnerName);
        const values = data.map(item => parseFloat(item.value)); // Mantén como números para escalado correcto

        this.chartSeries_deuda_cliente_postpago = [{
          name: 'Deuda Postpago', // Opcional: nombre para la serie
          data: values
        }];

        this.chartOptions_deuda_cliente_postpago = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true // Mantenido si es intencional
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4, // Opcional: suaviza las barras
              dataLabels: {
                position: 'top' // Muestra valor en la barra
              }
            }
          },
          dataLabels: {
            enabled: true, // Habilita labels formateados en las barras
            formatter: function (value) {
              const number = Number(value);
              return number.toLocaleString('es-VE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            },
            style: {
              fontSize: '12px',
              colors: ['#304758']
            },
            offsetX: 0,
          },
          xaxis: {
            categories: categories,
            labels: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                });
              },
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + ' (Deuda Postpago)';
              }
            }
          },
          colors: ['#FF5733'], // Color naranja/rojo para postpago; ajusta si prefieres
        };
      },
      chart_deuda_antiguedad(data) {
        const categories = data.map(item =>
          typeof item.antiguedad === 'string' ? item.antiguedad.replace('>', '') : item.antiguedad
        );
        const values = data.map(item => parseFloat(item.value)); // Mantén como números para escalado correcto

        this.chartSeries_deuda_antiguedad = [{
          name: 'Deuda por Antigüedad', // Opcional: nombre para la serie
          data: values
        }];

        this.chartOptions_deuda_antiguedad = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true // Mantenido si es intencional
          },
          plotOptions: {
            bar: {
              horizontal: false, // Barras verticales
              borderRadius: 4, // Opcional: suaviza las barras
              dataLabels: {
                position: 'top' // Muestra valor en la barra
              }
            }
          },
          dataLabels: {
            enabled: true, // Cambié a true para mostrar labels formateados; si prefieres false, cámbialo
            formatter: function (value) {
              const number = Number(value);
              return number.toLocaleString('es-VE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            },
            style: {
              fontSize: '12px',
              colors: ['#304758']
            },
            offsetY: -20, // Ajuste para vertical: mueve labels arriba de las barras
          },
          xaxis: {
            categories: categories,
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                });
              },
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + ' (Deuda)';
              }
            }
          },
          colors: ['#008FFB'], // Color azul; ajusta si prefieres
        };
      },
      chart_deuda_segmentacion(data) {
        const categories = data.map(item => item.segmentacion);
        const values = data.map(item => parseFloat(item.deuda_total)); // Mantén como números para escalado correcto

        this.chartSeries_deuda_segmentacion = [{
          name: 'Deuda por Segmentación', // Opcional: nombre para la serie
          data: values
        }];

        this.chartOptions_deuda_segmentacion = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: false // No stacked para segmentación individual; ajusta si prefieres
          },
          plotOptions: {
            bar: {
              horizontal: true, // Horizontal para mejor legibilidad de categorías largas
              borderRadius: 4, // Opcional: suaviza las barras
              dataLabels: {
                position: 'top' // Muestra valor en la barra
              }
            }
          },
          dataLabels: {
            enabled: true, // Habilita labels formateados en las barras
            formatter: function (value) {
              const number = Number(value);
              return number.toLocaleString('es-VE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            },
            style: {
              fontSize: '12px',
              colors: ['#304758']
            },
            offsetX: 0,
          },
          xaxis: {
            categories: categories,
            labels: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                });
              },
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (value) {
                const number = Number(value);
                return number.toLocaleString('es-VE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + ' (Deuda)';
              }
            }
          },
          colors: ['#FF6B6B'], // Color rojo para segmentación de deudas; ajusta si prefieres
        };
      },
      chart_deuda_segmentacion_prepago(data) {
        this.build_chart_segmentacion_tipo_cuenta(data, ['Prepago', 'Prepago recurrente'], 'deuda_segmentacion_prepago', '#00E396', 'Deuda Prepago');
      },
      chart_deuda_segmentacion_postpago(data) {
        this.build_chart_segmentacion_tipo_cuenta(data, ['Postpago'], 'deuda_segmentacion_postpago', '#FF5733', 'Deuda Postpago');
      },
      build_chart_segmentacion_tipo_cuenta(data, tiposCuenta, key, color, serieName) {
        const accepted = tiposCuenta.map(tipo => tipo.trim().toLowerCase());
        const filtered = (data || []).filter(
          item => accepted.includes(String(item.tipo_cuenta || '').trim().toLowerCase())
        );
        const totals = {};
        const categories = [];
        filtered.forEach(item => {
          const segmentacion = item.segmentacion;
          if (!(segmentacion in totals)) {
            totals[segmentacion] = 0;
            categories.push(segmentacion);
          }
          totals[segmentacion] += parseFloat(item.deuda_total) || 0;
        });
        const values = categories.map(segmentacion => totals[segmentacion]);

        this['chartSeries_' + key] = [{
          name: serieName,
          data: values
        }];

        this['chartOptions_' + key] = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: false
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4,
              dataLabels: {
                position: 'top'
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (value) {
              return formatNumberES(value);
            },
            style: {
              fontSize: '12px',
              colors: ['#304758']
            },
            offsetX: 0,
          },
          xaxis: {
            categories: categories,
            labels: {
              formatter: function (value) {
                return formatNumberES(value);
              },
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (value) {
                return formatNumberES(value) + ' (Deuda)';
              }
            }
          },
          colors: [color],
        };
      },
      // chart_deuda_antiguedad_afiliacion(data) {
      //   // Agrega por antiguedad: suma deuda por tipo_cuenta (agregando segmentaciones para Afiliados)
      //   console.log('chart_deuda_antiguedad_afiliacion', data);
      //   const antiquityMap = {};

      //   data.forEach(item => {
      //     const key = item.antiguedad;
      //     const tipo = item.tipo_cuenta;

      //     let deuda = Number(item.deuda_total);
      //     if (Number.isNaN(deuda)){
      //       console.log('item.deuda_total', item.deuda_total); 
      //       deuda = 0;
      //     }

      //     if (!antiquityMap[key]) {
      //       antiquityMap[key] = {};
      //     }

      //     if (!antiquityMap[key][tipo]) {
      //       antiquityMap[key][tipo] = 0;
      //     }

      //     antiquityMap[key][tipo] += deuda;
      //   });


      //   console.log('antiquityMap', antiquityMap);
      //   const categories = Object.keys(antiquityMap).sort(); // Ordena antigüedades (ajusta si necesitas orden específico)
      //   const afiliadoData = categories.map(cat => antiquityMap[cat].Afiliado);
      //   const noAfiliadoData = categories.map(cat => antiquityMap[cat]['No Afiliado']);

      //   this.chartSeries_deuda_antiguedad_afiliacion = [
      //     { 
      //       name: 'Afiliado', 
      //       data: afiliadoData 
      //     },
      //     { 
      //       name: 'No Afiliado', 
      //       data: noAfiliadoData 
      //     }
      //   ];

      //   this.chartOptions_deuda_antiguedad_afiliacion = {
      //     chart: {
      //       type: 'bar',
      //       height: 350,
      //       stacked: true // Stacked para mostrar composición por tipo dentro de cada antigüedad
      //     },
      //     plotOptions: {
      //       bar: {
      //         horizontal: true, // Horizontal para mejor legibilidad de categorías de antigüedad
      //         borderRadius: 4,
      //         dataLabels: {
      //           position: 'top'
      //         }
      //       }
      //     },
      //     dataLabels: {
      //       enabled: true,
      //       formatter: function (deuda_total) {
      //         const number = Number(deuda_total);
      //         return number.toLocaleString('es-VE', { 
      //           minimumFractionDigits: 2, 
      //           maximumFractionDigits: 2 
      //         });
      //       },
      //       style: {
      //         fontSize: '12px',
      //         colors: ['#304758']
      //       },
      //       offsetX: 0,
      //     },
      //     xaxis: {
      //       categories: categories,
      //       labels: {
      //         formatter: function (deuda_total) {
      //           const number = Number(deuda_total);
      //           return number.toLocaleString('es-VE', { 
      //             minimumFractionDigits: 2, 
      //             maximumFractionDigits: 2 
      //           });
      //         },
      //         style: {
      //           fontSize: '12px'
      //         }
      //       }
      //     },
      //     yaxis: {
      //       labels: {
      //         style: {
      //           fontSize: '12px'
      //         }
      //       }
      //     },
      //     tooltip: {
      //       y: {
      //         formatter: function (deuda_total) {
      //           const number = Number(deuda_total);
      //           return number.toLocaleString('es-VE', { 
      //             minimumFractionDigits: 2, 
      //             maximumFractionDigits: 2 
      //           }) + ' (Deuda)';
      //         }
      //       }
      //     },
      //     colors: ['#008FFB', '#FF5733'], // Azul para Afiliado, naranja para No Afiliado
      //     legend: {
      //       position: 'top',
      //       horizontalAlign: 'right'
      //     },
      //   };
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .card_kpis {
    background-color: white;
    border-radius: 10px;
  }
</style>
